import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

// projection date object interface
interface ProjectionDate {
  projectionstartdate: string;
}

// projection dates array interface
interface ProjectionDates {
  projectiondatelistitemwise: ProjectionDate[];
}

// slice Initial state interface
interface ProjectionDatesState {
  projectionDates: ProjectionDate[];
  error: string | null;
}

// Initial state
const initialState: ProjectionDatesState = {
  projectionDates: [],
  error: null,
};

// async thunk for API call
export const fetchItemProjectionDates = createAsyncThunk<ProjectionDates, { userId: string | null, modulecode: string }>(
  'projections/fetchItemProjectionDates',
  async ({ userId, modulecode }) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjectionItemWise/GetMenuProjectionItemWiseDate`, {
      userid: userId,
      modulecode: modulecode
    });

    // Check if the API response
    if (response.data.success) {     
      return response.data.data as ProjectionDates; // Return only the data part
    } else {
      throw new Error(response.data.errormessage || 'Failed to fetch projection dates');
    }
  }
);

// slice
const itemProjectionDatesSlice = createSlice({
  name: 'projectionDates',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItemProjectionDates.fulfilled, (state, action) => {
        state.projectionDates = action.payload.projectiondatelistitemwise;

      })
      .addCase(fetchItemProjectionDates.rejected, (state, action) => {
        state.error = action.error.message || 'Error fetching projection dates';
      });
  },
});

export default itemProjectionDatesSlice.reducer;
